export default __webpack_public_path__ + "static/media/hht2_ani_03.1600e9d1.png";